(function () {
  let loaded = false;

  function loadPredictiveSearch() {
    if (loaded) return;
    loaded = true;
    const src = document.documentElement.dataset.predictiveSearchSrc;
    if (!src) return;
    const script = document.createElement('script');
    script.type = 'module';
    script.src = src;
    document.head.appendChild(script);
  }

  function bindInput(input) {
    input.addEventListener('focus', loadPredictiveSearch, { once: true });
    input.addEventListener('input', loadPredictiveSearch, { once: true });
  }

  document.querySelectorAll('[data-predictive-search] input[type="search"]').forEach(bindInput);
})();
